var _style, _path, _path2, _polygon, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0428\\u0430\\u0440_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.4 357.2",
    style: {
      enableBackground: "new 0 0 850.4 357.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0A62AD;}\r\n\t.st1{fill:#E40434;}\r\n\t.st2{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.5,92c0-21.1,39.2-14.3,51.1-9.5l3.7-35C638.5,35.1,576.9,44.3,577,96.6c-0.8,51.5,75.1,44.5,75.1,69 c0,25.9-59.5,12.6-72.4,4.8l-6.8,35.1c44.2,19.5,128.1,15.2,125.8-43.4C698,105.2,623.5,115.2,623.5,92 M522.5,110.2 c0-45.7-61.7-46.3-61.2,0H522.5z M460.9,145.5c3.2,40.5,66.3,33.5,93.6,24.8l6.8,35c-63.8,24.4-149,8.5-149-74.5 c0-110.7,158.2-122.7,158.2-5.8c0,8.8-1,16.7-1.7,20.4H460.9z M682.6,82.5H707V152c0,36.6,9.2,63.8,49.6,63.8 c14.6,0,26.7-3.7,33.5-6.4l0-39.1c-24.1,4.5-35.9,6-35.9-26.1V1L707,1v46.4h-20.7L682.6,82.5z M762.3,82.5h27.8l9.7-17.7l-9.6-17.4 h-27.9V82.5z M144.8,212.4l41.2-165l11,168.5h46.2L229.1,1H157l-35.4,144.4L86.2,1H14.1L0,215.9h46.2l11-168.5l41.2,165H144.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.2,110.2c0-45.7-61.7-46.3-61.2,0H356.2z M294.6,145.5c3.2,40.5,66.3,33.5,93.6,24.8l6.8,35 c-63.8,24.4-149,8.5-149-74.5c0-110.7,158.2-122.7,158.2-5.8c0,8.8-1,16.7-1.7,20.4H294.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "815.3,1 850.4,64.8 815.3,128.9 780.2,128.9 815.3,64.8 780.2,1 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M769.5,308.5c0,1.1,0,2.2-0.2,3.1c-1,3.2-4.3,5.4-7.4,5.4c-3.6,0-6.1-1.9-6.1-5.7c0-5.2,5-7.7,13.8-7.7V308.5z  M790.5,296.4c0-14.8-7.1-26.1-27.3-26.1c-12.2,0-20.6,3.4-24.4,5.3l3.8,13.8c3.8-2.3,10.4-4.4,16.6-4.4c7.8,0,9.6,2.6,9.6,5v0.5 c-20,0.1-34.1,7.1-34.1,23c0,9.9,7.4,18.6,19.4,18.6c6.3,0,12.2-1.8,16.4-6.5h0.4l1.2,5.2h19.4c-0.7-3-1-8.5-1-14.4V296.4z  M679.4,271.6v16.5h16.5v42.7h21.7v-42.7h16.5v-16.5H679.4z M585.9,271.6v59.2h87.9v-59.2h-21.3v42.8h-12v-42.8h-21.3v42.8h-12 v-42.8H585.9z M548.9,285.6c6.5,0,9.1,7.5,9.1,15.6c0,9.5-3.2,15.6-9,15.6c-6.7,0-9.6-6.9-9.6-15.6 C539.4,293.4,541.8,285.6,548.9,285.6 M549.6,270.3c-20.1,0-32.4,12.5-32.4,31.3c0,19.2,13.6,30.5,31.2,30.5 c16.5,0,31.8-10,31.8-31.5C580.2,282.8,568,270.3,549.6,270.3 M442.7,249.8v81h21.7v-63.4h24.9v63.4h21.5v-81H442.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 850.4,
    height: 357.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logoNew.e89b58f06e55927fd108cad72050aaf4.svg";
export { ForwardRef as ReactComponent };